module.exports = __webpack_public_path__ + "img/logo_login.2c8f738f.png";